export default __webpack_public_path__ + "static/A_29-a64049909e5193fc9c2f61af5b253e1e.png";